import { makeObservable } from 'mobx';
import { Dashboard, EmbedDashboardResponse } from 'src/generated-api-client';
import { metabaseApi } from 'src/services/apiServices';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { Pager } from 'src/utils/mobx/Pager';
import { RequestHelper } from 'src/utils/RequestHelper';

export class MetabaseStoreClass extends BasicStore<
    Dashboard,
    Record<string, any>,
    unknown,
    unknown,
    EmbedDashboardResponse
> {
    constructor() {
        super();
        makeObservable(this);
    }

    pager = new Pager();
    api: BasicStoreApi<Dashboard, unknown, unknown, EmbedDashboardResponse> = {
        loadList: async () => {
            const response = await RequestHelper.unwrapFromAxiosPromise(
                metabaseApi.getDashboards(),
            );

            this.pager.setTotal(response.dashboards?.length || 0);

            return response?.dashboards || [];
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                metabaseApi.getEmbedDashboard({ id: Number(id) }, options),
            );
        },
    };
}

export const MetabaseStore = new MetabaseStoreClass();
